import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {DomSanitizer} from '@angular/platform-browser';
import {UserBalanceService} from '../../../../layout/user-balance.service';

@Component({
  selector: 'app-modal-window-message',
  templateUrl: './modal-window-message.component.html',
})
export class ModalWindowMessageComponent {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor(
    public domSanitizer: DomSanitizer,
    public userBalanceService: UserBalanceService,
  ) {
  }

  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }

  onOkClick() {
    this.modalWindowResponse.next({confirmed: true});
  }
}
